import React, { PropsWithChildren } from 'react';
import DesignSystemThemeProviderLegacy from './DesignSystemThemeProvider.legacy';
import DesignSystemThemeProviderAlpha from './DesignSystemThemeProvider.alpha';

const Provider = process.env.IS_LEGACY
  ? DesignSystemThemeProviderLegacy
  : DesignSystemThemeProviderAlpha;

const DesignSystemThemeProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <Provider>{children}</Provider>
);

export default DesignSystemThemeProvider;
